import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./index.css";
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import About from "./pages/About";
import Meesho from "./pages/Meesho";
import Flipkart from "./pages/Flipkart";
import Amazon from "./pages/Amazon";
import PDFMerge from "./pages/PDFMerge";
import CreateLabel from "./pages/CreateLabel";
import Blog from "./pages/Blog";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Router>
    <Navbar />
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/about" element={<About />} />
      <Route path="/meesho" element={<Meesho />} />
      <Route path="/flipkart" element={<Flipkart />} />
      <Route path="/amazon" element={<Amazon />} />
      <Route path="/pdf-merge" element={<PDFMerge />} />
      <Route path="/create-label" element={<CreateLabel />} />
      <Route path="/blog" element={<Blog />} />
    </Routes>
  </Router>
);
